import axios from "axios";

export const state   = { extensionSettings: null, extensionSettingsPromise: null, insideExtension: false };
export const getters = {
  insideExtension:   state => state.insideExtension,
  extensionSettings: state => state.extensionSettings
};

export const mutations = {
  saveExtensionSettings(state, { data }) {
    state.extensionSettings = { ...(state.extensionSettings || {}), ...(data || {}) };
  },
  saveExtensionSettingsPromise(state, { promise }) {
    state.extensionSettingsPromise = promise;
  },
  setInsideExtension(state, value) {
    state.insideExtension = value;
  }
};

export const actions = {
  async fetchSettings({ commit }) {
    if (state.extensionSettings)        return state.extensionSettings;
    if (state.extensionSettingsPromise) return state.extensionSettingsPromise;

    let promise = axios.get("/v3/users/extension_settings").then(response => {
      commit("saveExtensionSettings", { data: response.data.data });
      return response.data.data;
    })

    commit("saveExtensionSettingsPromise", { promise });
    return promise;
  },
  async saveSettings({ commit }, { data }) {
    let promise = axios.post("/v3/users/extension_settings", { data }).then(response => {
      commit("saveExtensionSettings", { data: response.data.data });
      return response.data.data;
    })

    commit("saveExtensionSettingsPromise", { promise });
    return promise;
  }
}
